import React from 'react';
import Box from '@mui/material/Box';
import RowBox from 'components/RowBox';

export default function CardItem(props) {
    const onChangeFunc = props.onChange || function() {};
    const currValue = props.value || 0;
    const boxCss = {
        backgroundColor: 'white',
        width: '25px',
        height: '25px',
        textAlign: 'center',
        verticalAlign: 'center',
        fontSize: '22px',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
    return (
        <RowBox sx={{ flexWrap: 'nowrap', border: '1px solid #CCCCCC80'  }}>
            <Box sx={{ ...boxCss, cursor: 'pointer', color: 'red' }}
                onClick={() => { if (currValue > 0) onChangeFunc(currValue - 1); } }>
                &minus;
            </Box>
            <Box sx={{ ...boxCss, fontSize: '15px', backgroundColor: currValue > 0 ? '#60b246' : 'white',
                color: currValue > 0 ? 'white' : 'black', }}>
                {currValue}
            </Box>
            <Box sx={{ ...boxCss, cursor: 'pointer', color: '#60b246' }}
                onClick={() => onChangeFunc(currValue + 1) }>
                +
            </Box>
        </RowBox>
    )
}
